import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "custom-modal-wrap overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[100] md:inset-0 h-modal md:h-full justify-center items-center flex" }
const _hoisted_2 = { class: "relative pt-[80px] pb-[80px] grid items-center p-4 w-full h-full md:h-[100vh] max-w-[820px]" }
const _hoisted_3 = { class: "relative rounded-xl shadow bg-theme-modalbg" }
const _hoisted_4 = {
  class: "grid grid-cols-1 lg:grid-cols-1 gap-3",
  style: {"font-family":"Arial"}
}
const _hoisted_5 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_6 = { class: "w-[800px] rounded-2xl shadow-[0px_25px_50px_-12px_rgba(0,0,0,1.00)] inline-flex flex-col justify-start items-center overflow-hidden" }
const _hoisted_7 = { class: "self-stretch px-6 py-4 bg-green-500 inline-flex justify-start items-start gap-6" }
const _hoisted_8 = { class: "flex-1 self-stretch inline-flex flex-col justify-center items-center gap-0.5" }
const _hoisted_9 = { class: "self-stretch justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight line-clamp-1" }
const _hoisted_10 = { class: "flex justify-end items-center gap-4" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "self-stretch px-6 pt-6 pb-8 bg-zinc-800 flex flex-col justify-start items-start gap-4 overflow-hidden" }
const _hoisted_13 = {
  key: 0,
  class: "self-stretch flex justify-center py-8"
}
const _hoisted_14 = { class: "self-stretch justify-center text-white text-base font-bold font-['Roboto'] leading-5 tracking-tight" }
const _hoisted_15 = {
  key: 0,
  class: "self-stretch justify-center text-neutral-400 text-sm py-4"
}
const _hoisted_16 = {
  key: 1,
  class: "max-h-[350px] overflow-y-auto"
}
const _hoisted_17 = { class: "grid grid-cols-2 self-stretch inline-flex justify-start items-start gap-4 flex-wrap" }
const _hoisted_18 = { class: "admin-table flex flex-row w-full justify-between" }
const _hoisted_19 = { class: "cursor-pointer text-sm min-w-[200px] self-stretch flex justify-start items-start gap-2" }
const _hoisted_20 = ["id", "value", "checked", "onChange"]
const _hoisted_21 = { class: "flex-1 inline-flex flex-col justify-start items-start gap-0.5" }
const _hoisted_22 = { class: "self-stretch justify-center text-white text-base font-medium font-['Roboto'] leading-6 line-clamp-1" }
const _hoisted_23 = { class: "self-stretch justify-center text-neutral-400 text-xs font-normal font-['Roboto'] leading-4 line-clamp-1" }
const _hoisted_24 = { class: "min-w-[120px] p-1 bg-neutral-900 rounded-md inline-flex flex-col justify-start items-center gap-0.5" }
const _hoisted_25 = { class: "text-center justify-center text-white text-xs font-normal font-['Roboto'] leading-4 line-clamp-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, "Manage Locations for [" + _toDisplayString(_ctx.profile?.name || 'Profile') + "]", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "self-stretch justify-center text-white text-sm font-normal font-['Roboto'] leading-4" }, "Select which locations should use this business branding profile. Locations can only be assigned to one branding at a time.", -1))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePop && _ctx.closePop(...args))),
                    "data-configuration": "Text-L",
                    "data-fill": "True",
                    "data-show-icon": "False",
                    "data-state": "Default",
                    class: "w-24 h-11 p-4 rounded outline outline-1 outline-offset-[-1px] outline-white flex justify-center items-center gap-2 cursor-pointer"
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "text-center justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest" }, "CANCEL", -1)
                  ]))]),
                  _createElementVNode("button", {
                    disabled: !_ctx.selectedLocations.length,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.assignLocations && _ctx.assignLocations(...args))),
                    "data-configuration": "Text-L",
                    "data-fill": "True",
                    "data-show-icon": "False",
                    "data-state": "Default",
                    class: "w-24 h-11 p-4 bg-white rounded flex justify-center items-center gap-2 cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "text-center justify-center text-green-500 text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest" }, "Assign", -1)
                  ]))], 8, _hoisted_11)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_block_loading)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedCount) + " locations selected", 1),
                      (!_ctx.locations.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, "No locations found."))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: location.id,
                                  class: _normalizeClass(["self-stretch p-2 rounded-md outline outline-1 outline-offset-[-1px] inline-flex justify-start items-start gap-2 min-w-[280px]", _ctx.selectedLocations.includes(location.id)?'bg-green-500/20 outline-green-500':'bg-zinc-800 outline-zinc-700'])
                                }, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("label", _hoisted_19, [
                                      _createElementVNode("input", {
                                        id: `location-${location.id}`,
                                        type: "checkbox",
                                        value: location.id,
                                        class: "mr-3 mt-0.5 w-[20px] h-[20px] focus:ring-0",
                                        checked: _ctx.selectedLocations.includes(location.id),
                                        onChange: ($event: any) => (_ctx.toggleLocation(location.id))
                                      }, null, 40, _hoisted_20),
                                      _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(location.name), 1),
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatAddress(location)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-center justify-center text-neutral-400 text-xs font-normal font-['Roboto'] leading-4" }, "Currently:", -1)),
                                      _createElementVNode("div", _hoisted_25, _toDisplayString(location.businessBrandProfile?.name || '—'), 1)
                                    ])
                                  ])
                                ], 2))
                              }), 128))
                            ])
                          ]))
                    ], 64))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}